import RightIcon from '../../../Icons/coaching/funnel/right-icon.svg'
import CrownIcon from '../../../Icons/landingpages/JoinAffiliate/crown.svg'
import GradientButton from '../../Buttons/GradientButton'
import { ContainerWrapper } from '../../Container'
import SectionHeading from '../../HomePage/SectionHeading'

const bulletPoints = [
    {
        title: 'Earn Commissions',
        description:
            'Receive a 5% commission on net revenue for all orders from referrals',
        icon: RightIcon,
    },
    {
        title: 'Discount Code for Referrals',
        description:
            'Provide your referrals with a special discount code to encourage their purchases.',
        icon: RightIcon,
    },
    {
        title: 'Exclusive Resources',
        description:
            'Access tailored marketing and branding assets to enhance your promotions.',
        icon: RightIcon,
    },
    {
        title: 'Top-Tier Affiliate Support',
        description:
            'Top affiliates get a custom landing page, dedicated marketing coach, and access to have an OLM team member on community training, webinars, etc.',
        icon: CrownIcon,
    },
]

const AffiliateButton = ({ onApplyClick }) => {
    return (
        <GradientButton onClick={onApplyClick}>
            Apply To Become an Affiliate
        </GradientButton>
    )
}

function FeatureAffiliate({
    imagePath = '/assets/landing/join-affiliate/feature-1-2x.png',
    mobileImagePath = '/assets/landing/join-affiliate/feature-1.png',
    extraCallAction = false,
    CallActionText = 'Apply To Become an Affiliate',
    bulletColor = 'olm-green',
    bulletSeperateDesc = true,
    ...props
}) {
    const CallActionButton = () => (
        <div className="w-96 max-w-full">
            <AffiliateButton onApplyClick={props.onApplyClick} />
        </div>
    )

    const alignment = 'left'
    const bg = 'bg-transparent'
    const size = 'xl'

    const alignmentClass =
        alignment === 'left' ? 'order-last lg:ml-10' : 'lg:mr-10'

    const shouldAddPadding = bg == 'bg-transparent' ? false : true

    const title = (
        <>
            Why Partner with <br /> Open Letter Marketing?
        </>
    )

    return (
        <div className={`${bg} rounded-8xl md:rounded-8xl`}>
            <ContainerWrapper>
                <div
                    className={`${shouldAddPadding && 'pb-12 md:py-16'}
                    ${size === 'xl' ? 'md:max-w-5xl m-auto' : 'md:max-w-full'}
                    px-4 md:px-0 lg:flex lg:items-start lg:justify-between space-y-10 lg:space-y-0`}>
                    <div className="block md:hidden px-2 text-center">
                        <SectionHeading size={size}>{title}</SectionHeading>
                    </div>

                    <div className="mt-8 w-full md:hidden lg:w-4/12">
                        <img
                            src={mobileImagePath}
                            alt={title}
                            className="w-full h-auto"
                        />
                    </div>
                    <div
                        className={`w-full px-2 md:px-0 lg:w-6/12 md:pl-0 mx-auto text-center lg:text-left ${alignmentClass}`}>
                        <div className="hidden md:block">
                            <SectionHeading size={size}>
                                <p className="text-left">{title}</p>
                            </SectionHeading>
                        </div>
                        <div className="mt-8 space-y-6">
                            {bulletPoints &&
                                bulletPoints.length > 0 &&
                                bulletPoints.map((Point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-start space-x-3">
                                        <span
                                            className={`inline-block  p-2 rounded-full text-${bulletColor}`}>
                                            <Point.icon />
                                        </span>
                                        <div className="text-left">
                                            <p className="mt-1 space-x-1 text-black">
                                                <span className="leading-6 font-bold text-black">
                                                    {Point.title}:
                                                </span>
                                                {bulletSeperateDesc ? (
                                                    <p> {Point.description} </p>
                                                ) : (
                                                    <span>
                                                        {Point.description}
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            <div className="space-y-2 max-w-full">
                                <CallActionButton>
                                    {CallActionText}
                                </CallActionButton>
                                {extraCallAction && (
                                    <p className="olm-gradient-text italic font-semibold text-center">
                                        Limited Time Offer
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className=" w-full hidden md:block lg:w-8/12">
                        <img
                            src={imagePath}
                            alt={title}
                            className="w-full h-auto"
                        />
                    </div>
                </div>
            </ContainerWrapper>
        </div>
    )
}

export default FeatureAffiliate
